/* global google */
// do not delete above line. Needed for google address to function

import { basicAccountInfo } from "api/basic_account_info";
import { generic_get_api } from "api/generic_api";
import { Component, useState, useEffect } from "react";
import { Button, Modal, Spinner } from 'react-bootstrap';
import { CODE_SEARCH } from 'utils/constants';
import { EventNames, trackEvent } from 'utils/mixpanel';
import { truncateText } from "utils/helpers";


const items_per_page = 10;


class CodeSearch extends Component {

    constructor(props) {
        super(props);

        this.state = {
            searching: false,
            search_string: null,
            search_result: [],
            selected_entry: null,
            address: null,
            index: 0,
        };
        this.resetAndSubmit = this.resetAndSubmit.bind(this);
        this.submitSearch = this.submitSearch.bind(this);
    }

    resetAndSubmit() {
        this.setState({}, this.submitSearch);
    }

    submitSearch() {
        this.setState({ searching: true })
        let query_params = {
            search_string: this.state.search_string,
        }

        generic_get_api(CODE_SEARCH, query_params)
            .then(
                data => {
                    
                    let selected_entry = null;

                    // if (data.result && data.result.length > 0 && !data.answer){
                    //     selected_entry = data.result[0];
                    // }

                    let paragraphs = null;

                    if (data.answer) {
                        paragraphs = data.answer.paragraphs;
                    }

                    this.setState({
                        is_keyword_question: data.is_keyword_question,
                        search_result: data.result,
                        result_topics: data.topics,
                        document_source_types: data.document_source_types,
                        searching: false,
                        selected_entry: selected_entry,
                        answer_paragraphs: paragraphs,
                        address: data.address,
                        semantic_matches: data.semantic_matches,
                        index: 0,
                    });
                }
            )
            .catch(error => {
                this.setState({ searching: false })
            });

    }

    componentDidMount() {
        trackEvent(EventNames.PAGE_LOAD, { 'data_1': 'code_search' });
        basicAccountInfo()
            .then(
                data => {
                    this.setState({ session_ok: true });
                }
            ).catch(error => {
                if (error?.name === 'LOGIN_ERROR') {
                    this.props.history.push('/login');
                }
            });
    }

    render() {
        const { searching, search_string, result_topics, semantic_results, search_result, selected_entry, index, answer_paragraphs, address, document_source_types, semantic_matches } = this.state;
        
        const getSummarySections = (section_summary_list, max_length) => {
            let result = [];
            let total_length = 0;

            for (let i = 0; i < section_summary_list.length; i++) {
                let summary_part = section_summary_list[i];
                if (total_length + summary_part.length <= max_length) {
                    result.push(summary_part);
                    total_length += summary_part.length;
                }
                else {
                    let available_length = max_length - total_length;
                    let partial_part = summary_part.substring(0, available_length - 1) + "...";
                    result.push(partial_part);
                    total_length = max_length;
                    break;
                }
            }
            return result;
        }

        const currentResultPage = () => {
            if(semantic_results) {
                return semantic_matches.slice(index, index + 10); 
            }
            return search_result.slice(index, index + 10);
        }

        return (
            <div class="container codeSearch ps-4">

                <div class="container searchInput mt-3">
                    <div class="row"><div class="col fs-4 text-center">Planning Documents Search</div></div>
                    <div class="row mt-3">
                        <div class="col">
                            <div class="input-group">
                                <input type="text" class="form-control" placeHolder="keywords or phrase" id="search_string" onChange={(e) => this.setState({ search_string: e.target.value })} />
                                {
                                    searching ?
                                        <Button onClick={this.resetAndSubmit} disabled={!search_string || searching} role="button">
                                            <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />&nbsp;
                                            Searching
                                        </Button>
                                        :
                                        <Button onClick={this.resetAndSubmit} disabled={!search_string || searching} role="button">
                                            Search
                                        </Button>
                                }

                            </div>
                        </div>
                    </div>
                </div>
                <div class="container mt-5">
                    <div class="row">
                        <div class="col-3">
                            <TopicsFilter topics={result_topics} />
                            <DocumentTypeFilter document_source_types={document_source_types} />
                            {
                                semantic_matches && semantic_matches.length > 0 &&
                                <div class="row mt-4">
                                    <div class="col-auto pe-1">
                                        <input class="form-check-input" type="checkbox" name="topicCheckBox" id="semantic" onChange={(e) => this.setState({semantic_results: e.currentTarget.checked})  }/>
                                    </div>
                                    <div class="col ps-1">Semantic matches ({semantic_matches.length})</div>
                                </div>
                            }
                        </div>
                        <div class="col-5">
                            <AnswerSection answer_paragraphs={answer_paragraphs} address={address}/>
                            
                            {
                                search_result && search_result.length > 0 && 
                                <div class="row mt-3"><div class="col text-end text-secondary"><small>Showing {index + 1} - {index + 10} of {search_result.length}</small></div></div>
                            }
                            {
                                currentResultPage().map((result_entry) => {
                                    return  <div class={`container mt-2 border rounded sectionEntry p-2 ${selected_entry === result_entry ? "selected border-primary" : ""}`}
                                                role="button" onClick={() => {this.setState({selected_entry: result_entry}); window.scrollTo(0, -100);}}>
                                                <div class="row">
                                                    <div class="col text-end text-primary">{result_entry.type}</div>
                                                </div>
                                                <div class="row mt-2">
                                                    <div class="col fw-semibold">SEC. {result_entry.section_id} {result_entry.section_title}</div>
                                                </div>
                                                {
                                                    result_entry.section_id == '102' ?
                                                        <>
                                                            {
                                                                result_entry.hit_list.map((hit) => {
                                                                    return <div class="row mt-2">
                                                                        <div class="row ms-1"><div class="col fst-italic"><i class="fa-regular fa-file fa-sm"></i>&nbsp;{hit.definition_term}</div></div>
                                                                        {hit.highlights ?
                                                                            <div class="row mt-1 ms-4">
                                                                                <div class="col">
                                                                                    <span dangerouslySetInnerHTML={{ __html: truncateText(hit.highlights, 300, true) }} className="p-0" />
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            <div class="row mt-1 ms-4">
                                                                                <div class="col">
                                                                                    {truncateText(hit.text, 300, true)}
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                })
                                                            }
                                                        </>
                                                        :
                                                        <>
                                                            {
                                                                result_entry.hit_list.map((hit) => {
                                                                    return <div class="row mt-2">
                                                                        {hit.highlights ?
                                                                            <div class="row mt-1 ms-1">
                                                                                <div class="col">
                                                                                    <span dangerouslySetInnerHTML={{ __html: truncateText(hit.highlights, 300, true) }} className="p-0" />
                                                                                </div>
                                                                            </div>
                                                                            :
                                                                            <div class="row mt-1 ms-1">
                                                                                <div class="col">
                                                                                    {truncateText(hit.text, 300, true)}
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                })
                                                            }
                                                        </>
                                                }
                                                <div class="row mt-4">
                                                    <div class="col" style={{display: "flex", flexWrap: "wrap", rowGap: "5px"}}>
                                                        { result_entry.topics.map((result_topic) => {
                                                            return <><input type="submit" value={result_topic} className="resultTopicLabel"/>&nbsp;</>
                                                        })}
                                                    </div>
                                                </div>

                                    </div>
                                })
                            }
                        </div>
                        <div class="col-4">
                            {
                                selected_entry && 
                                <div class="container mt-5 border rounded sectionDetail p-3">
                                    <div class="row">
                                        <div class="col fw-bold fs-5">SEC. {selected_entry.section_id}&nbsp;
                                            {
                                                selected_entry.type === 'Planning Code' ?
                                                <a href={`/code/code_sections?section_id=${selected_entry.section_id}`} className="text-decoration-none" target="_blank" role="button">
                                                    <i class="fa-solid fa-arrow-up-right-from-square fa-xs"></i>
                                                </a>
                                                :
                                                <a href={selected_entry.external_url} className="text-decoration-none" target="_blank" role="button">
                                                    <i class="fa-solid fa-arrow-up-right-from-square fa-xs"></i>
                                                </a>
                                            }
                                        
                                        </div>
                                    </div>
                                    <div class="row mt-2"><div class="col fw-semibold fs-5">{selected_entry.section_title}</div></div>

                                    { selected_entry.section_summary_list && selected_entry.section_summary_list.length > 0 &&
                                        <div class="row mt-4 ms-2 me-2 p-3 border rounded sectionDetailSummary">
                                            <div class="col text-secondary">
                                                {
                                                    getSummarySections(selected_entry.section_summary_list, 800).map(part => {
                                                        return <div class="row mt-2"><div class="col">{part}</div></div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                    }
                                    
                                    <ReferencesComponent links={selected_entry.outgoing_links} title="References"/>
                                    <ReferencesComponent links={selected_entry.incoming_links} title="Referenced in"/>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function AnswerSection(props) {
    const {answer_paragraphs, address} = props;
    const [expanded, setExpanded] = useState(false);

    // Collapse the links when a new answer is selected.
    useEffect(() => {
        setExpanded(false);
    }, [answer_paragraphs]);

    if (!answer_paragraphs) { return null; }

    return( 
           
        <div class="container mt-2 mb-4 border rounded p-3">
            <div class="row mb-3"><div class="col fw-semibold"><i class="fa-solid fa-wand-magic-sparkles"></i> AI Overview</div></div>
            {
                address && address.street_name && 
                <div class="container">
                    <div class="row"><div class="col">{address.street_number} {address.street_name} {address.street_suffix}, San Francisco, CA</div></div>
                    <div class="row"><div class="col"><hr></hr></div></div>
                </div>
            }
            { answer_paragraphs.map((p, index) => {
                return  <>
                        {
                            (expanded || index < 2) &&
                            <div class="row mb-2">
                                <div class="col">
                                    {p.paragraph_text} (SEC. {p.source_section}&nbsp;<span className="text-primary" role="button"><i class="fa-solid fa-sm fa-arrow-up-right-from-square"></i></span>)
                                </div>
                            </div>
                        }
                       
                        </>
                        
            })}
            {
                !expanded && answer_paragraphs.length > 2 && 
                <div class="row mt-4"><div class="col text-center">
                    <Button variant="outline-primary" size="sm" onClick={()=>setExpanded(true)}>Show more</Button>
                </div></div>
            }
        </div>
    )             
}

function TopicsFilter(props) {
    const {topics} = props;
    const [expanded, setExpanded] = useState(false);

    if (!topics || topics.length <= 0) { return null; }

    return( 
            <>
                <div class="row"><div class="col fw-semibold">Topics</div></div>
                {
                    topics.map((topic_entry, index) => {
                        return  <> { (expanded || (!expanded && index <= 4)) &&
                                        <div class="row mt-1">
                                            <div class="col-auto pe-1">
                                                <input class="form-check-input" type="checkbox" name="topicCheckBox" id={topic_entry}/>
                                            </div>
                                            <div class="col ps-1">{topic_entry[0]} ({topic_entry[1]})</div>
                                        </div>
                                    }
                                </>
                    })
                }
                {
                    !expanded && topics.length > 5 &&
                    <div class="row mt-2"><div class="col fst-italic text-secondary" role="button" onClick={()=>setExpanded(true)}>Show more...</div></div>
                }
                {
                    expanded && 
                    <div class="row mt-2"><div class="col fst-italic text-secondary" role="button" onClick={()=>setExpanded(false)}>Show less...</div></div>
                }
                <div class="row"><div class="col me-5"><hr></hr></div></div>
            </>
        )

}

function DocumentTypeFilter(props) {
    const {document_source_types} = props;
    const [expanded, setExpanded] = useState(false);

    if (!document_source_types || Object.keys(document_source_types).length <= 0) { return null; }

    return( 
            <>
                <div class="row mt-4"><div class="col fw-semibold">Source documents</div></div>
                {
                    Object.entries(document_source_types).map(([source, count], index) => {
                        return  <> { (expanded || (!expanded && index <= 4)) &&
                                        <div class="row mt-1">
                                            <div class="col-auto pe-1">
                                                <input class="form-check-input" type="checkbox" name="topicCheckBox" id={source}/>
                                            </div>
                                            <div class="col ps-1">{source} ({count})</div>
                                        </div>
                                    }
                                </>
                    })
                }
                
                {
                    !expanded && Object.keys(document_source_types).length > 5 &&
                    <div class="row mt-2"><div class="col fst-italic text-secondary" role="button" onClick={()=>setExpanded(true)}>Show more...</div></div>
                }
                {
                    expanded && 
                    <div class="row mt-2"><div class="col fst-italic text-secondary" role="button" onClick={()=>setExpanded(false)}>Show less...</div></div>
                }
                <div class="row"><div class="col me-5"><hr></hr></div></div>
            </>
        )

}

function ReferencesComponent(props) {
    const {links, title} = props;
    const [expanded, setExpanded] = useState(false);

    // Collapse the links when a new entry is selected.
    useEffect(() => {
        setExpanded(false);
    }, [links]);

    if(!links || links.length <= 0) {
        return null;
    }

    return (<div class="row mt-4 ms-2 me-2 p-3 border rounded sectionDetailSummary">
                {
                    links && links.length > 0 &&
                    <>
                        <div class="row mb-1" onClick={() => setExpanded(!expanded)} role="button">
                            <div class="col fw-bold">
                                {
                                    expanded ? <i class="fa-solid fa-angle-down"></i> : <i class="fa-solid fa-angle-right"></i>
                                }
                                &nbsp;&nbsp;<i class="fa-solid fa-link"></i>&nbsp;{title}
                            </div>
                        </div>
                        {
                            expanded && links.map(link => {
                                return  <div class="container mt-4">
                                            <div class="row">
                                                <div class="col fw-semibold">
                                                    <a role="button" href={`/code/code_sections?section_id=${link.section_id}`} target="_blank"
                                                        className="text-decoration-none fw-semibold text-primary">SEC. {link.section_id}&nbsp;
                                                        <i class="fa-solid fa-arrow-up-right-from-square fa-xs"></i></a>
                                                </div>
                                            </div>
                                            <div class="row mt-1"><div class="col text-secondary fw-semibold">{link.title}</div></div>
                                            <div class="row mt-2"><div class="col text-secondary">{truncateText(link.summary, 100, true)}</div></div>
                                            <div class="row mt-2">
                                                <div class="col" style={{display: "flex", flexWrap: "wrap", rowGap: "5px"}}>
                                                    { link.topics.map((topic) => {
                                                        return <><input type="submit" value={topic} className="resultTopicLabel"/>&nbsp;</>
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                            })
                        }
                    </>
                }
            </div>
    )
}


CodeSearch.displayName = "CodeSearch";
export default CodeSearch;